<!--
 * @Author: your name
 * @Date: 2020-11-03 15:29:47
 * @LastEditTime: 2021-07-13 14:22:05
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \znjz-vue\src\App.vue
-->
<template>
  <div id="app">
    <router-view />
    <Service />
  </div>
</template>

<script>
import Service from "./components/public/service";
export default {
  name: "App",
  components: { Service },
  data() {
    return {};
  },
  mounted() {
    let goUrl = this.isMobile();
    if (goUrl == 1) {
      //移动端地址
      setTimeout(() => {
        window.location = "http://m.91aioc.com/#/";
      }, 200);
    }
  },
  methods: {
    isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      // localStorage.setItem('ismobile',flag ? 1 : 0);
      let goUrl = flag ? 1 : 0;
      return goUrl;
    }
  }
};
</script>

<style lang="scss">
#app {
  height: 100%;
}
body,
html {
  color: #444;
  height: 100%;
}
.el-button {
  border: none;
  border-radius: 8px;
}
.Ai-btn {
  width: 120px;
  height: 48px;
  background: #4165ff;
  box-shadow: 0px 14px 24px 0px rgba(65, 101, 255, 0.32);
  color: #fff;
  text-align: center;
}
h1 {
  font-size: 18px;
  font-weight: 500;
}

.btn {
  height: 40px;
  width: 96px;
  margin-top: 150px;
  --hue: 190;
  position: relative;
  font-size: 14px;
  line-height: 40px;
  color: white;
  text-decoration: none;
  text-transform: uppercase;
  background-color: hsl(var(--hue), 100%, 100%);
  border: 1px solid hsl(var(--hue), 100%, 100%);
  outline: transparent;
  overflow: hidden;
  cursor: pointer;
  user-select: none;
  white-space: nowrap;
  transition: 0.25s;
  // border-color: #fff;

  &:hover {
    background: hsl(var(--hue), 100%, 31%);
  }

  .primary {
    --hue: 187;
  }

  &-ghost {
    color: hsl(var(--hue), 100%, 100%);
    background-color: transparent;
    border-color: hsl(var(--hue), 100%, 100%);

    &:hover {
      color: white;
    }
  }

  &-shine {
    color: white;

    &::before {
      position: absolute;
      content: "";
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: linear-gradient(
        120deg,
        transparent,
        hsla(var(--hue), 100%, 100%, 0.5),
        transparent
      );
      transform: translateX(-100%);
      transition: 0.6s;
    }

    &:hover {
      background: transparent;
      box-shadow: 0 0 20px 10px hsla(var(--hue), 100%, 100%, 0.5);
    }

    &:hover::before {
      transform: translateX(100%);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/App.vue